import type { Enums } from "../types";

/**
 * The colour a return run's state carries, so a list scanned by eye reads as sites being cleared.
 *
 * `canceled` is zinc rather than red: nothing was undone by it — whatever the site already handed
 * back is on the shelf and stays booked — so it is a run nobody works any more, not a failure.
 */
export function getReturnOrderStateColor(state: Enums<"returnOrderState">): Enums<"color"> {
	switch (state) {
		case "open":
			return "amber";
		case "in-progress":
			return "blue";
		case "complete":
			return "emerald";
		case "canceled":
			return "zinc";
	}
}
